import { render, staticRenderFns } from "./FilterBadge.vue?vue&type=template&id=56760ece&"
import script from "./FilterBadge.vue?vue&type=script&lang=js&"
export * from "./FilterBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports